/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div class="wrapp-coupon-manager-action">
    <button class="btn btn-primary btn-secondary-small full-width btn-secondary-with-icon btn-rounded justify-content-between" @click.prevent="manageCoupons">
      <span class="text">{{ $t('manage-coupons') }}</span>
      <svg class="o-icon"><use xlink:href="#edit"></use></svg>
    </button>
    <p class="t-normal text-center mt-2 cl-grey" v-show="activeCoupons.length"><b>{{activeCoupons.length}}</b> {{$t('applied-coupons')}}</p>
  </div>
</template>

<script>
export default {
  name: 'CouponsManagerButton',
  computed: {
    activeCoupons () {
      return this.$store.getters['cart/getAppliedCoupons']
    }
  },
  methods: {
    manageCoupons () {
      const componentToLoad = import('theme/components/Checkout/Cart/Coupons/CouponsManager.vue')
      this.$store.dispatch('ui/loadBottomActiveComponent', { component: componentToLoad })
    }
  }
}
</script>
